<template>
  <PageFooter />
</template>

<script>
  import PageFooter from "../../../../views/Parents/components/PageFooter";
  export default {
    name: "Footer",
    components: {
      PageFooter,
    },
    data() {
      return {};
    },
    created() {},
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style scoped></style>
